<template>
  <div class="selectGrop pointer">
    <NavBar title="批量操作"></NavBar>
    <div class="contentBox">
      <div v-if="emptyShow">
        <div class="card" v-for="(item, index) in cardList" :key="item.id">
          <div class="information">
            <div class="mationLeft" @click.stop="unfold(index)">
              <div class="nameTop">
                <div class="groupNameBox">
                  <div class="groupName">{{ item.groupName }}</div>
                  <div class="instanceLength">
                    共{{ item.instanceList.length }}台
                  </div>
                </div>
                <img
                  v-show="item.showStatus"
                  src="@/assets/imgs/groupingTop1.png"
                  alt=""
                />
                <img
                  v-show="!item.showStatus"
                  src="@/assets/imgs/groupingBottom1.png"
                  alt=""
                />
              </div>
            </div>
            <div class="mationRight">
              <van-checkbox
                v-model="item.result"
                checked-color="#8572eb"
                :ref="'checkboxGroup' + index"
                @click="checkAllMember(index, item.result)"
                :disabled="item.instanceList.length > 0 ? false : true"
              ></van-checkbox>
            </div>
          </div>
          <div
            class="listEquipment"
            v-show="item.showStatus && item.instanceList.length > 0"
          >
            <van-checkbox-group v-model="result" :ref="'checkboxes' + index">
              <van-cell-group :border="false">
                <van-cell
                  v-for="(list, index1) in item.instanceList"
                  :key="list.id"
                  clickable
                  @click.stop="toggle(index, index1)"
                  :border="false"
                  class="cellItem"
                >
                  <template #title>
                    <div class="shebei_title">
                      <div class="shebei_content">
                        <p class="p1">
                          <span class="deviceType">{{
                            getDeviceType(list.vipName, list.deviceVersionCode)
                          }}</span>
                          {{ list.instanceName }}
                        </p>
                        <div class="p2">
                          <img
                            class="idIcon"
                            src="@/assets/imgs/ID.png"
                            alt=""
                          />
                          <p class="id">{{ list.instanceId }}</p>
                        </div>
                      </div>
                      <!-- <van-count-down
                      class="instanceItem"
                      :time="list.expireSeconds * 1000"
                      :format="
                        list.expireSeconds * 1000 > 86400000
                          ? '剩余时间:DD天HH小时'
                          : '剩余时间:HH小时mm分钟'
                      "
                    /> -->
                      <div class="instanceItem">
                        剩余时间：{{ formatSeconds(list.expireSeconds) }}
                      </div>
                    </div>
                  </template>
                  <template #right-icon>
                    <van-checkbox
                      :name="list"
                      checked-color="#8572eb"
                      :ref="'checkboxes' + index + index1"
                    />
                  </template>
                </van-cell>
              </van-cell-group>
            </van-checkbox-group>
          </div>
        </div>
      </div>

      <van-empty
        v-else
        class="custom-image"
        :image="require('@/assets/imgs/empty.png')"
        description="暂时没有可操作的云手机哦！"
      />
    </div>
    <div class="baseBox">
      <div class="selectBox">
        <div class="selectText">已选择{{ result.length }}台云手机</div>
        <div class="allSelect" @click="onAllChecked">
          <van-checkbox v-model="allChecked" checked-color="#8572eb"
            >全选</van-checkbox
          >
        </div>
      </div>
      <div class="ul">
        <div class="li">
          <img
            @click="onOperate('重启')"
            src="@/assets/icons/restartIcon.png"
            alt=""
          />
          <p>重启</p>
        </div>
        <div class="li" @click="onOperate('批量续费')">
          <img src="@/assets/icons/renew.png" alt="" />
          <p>批量续费</p>
        </div>
        <div class="li" @click="onOperate('恢复出厂')">
          <img src="@/assets/icons/factoryResetIcon.png" alt="" />
          <p>恢复出厂</p>
        </div>
        <div class="li" @click="onOperate('更换机型')">
          <img src="@/assets/icons/newAircraft.png" alt="" />
          <p>更换机型</p>
        </div>
        <div class="li" @click="onOperate('重命名')">
          <img src="@/assets/icons/nameIcon.png" alt="" />
          <p>重命名</p>
        </div>

        <div class="li" @click="onOperate('管理分组')">
          <img src="@/assets/icons/minuteIcon.png" alt="" />
          <p>管理分组</p>
        </div>
        <div class="li" @click="onOperate('复制ID')">
          <img src="@/assets/icons/duplication.png" alt="" />
          <p>复制ID</p>
        </div>
      </div>
    </div>
    <ToolPopupCollection :result="result" ref="childRef"></ToolPopupCollection>
  </div>
</template>
        
  <script>
import { groupList } from "@/api/index.js";
import NavBar from "@/components/NavBar.vue";
import ToolPopupCollection from "@/components/homePage/ToolPopupCollection.vue";
import { Toast } from "vant";
import buyCode from "@/utils/buyCode";
export default {
  name: "BatchOperation",
  components: {
    NavBar,
    ToolPopupCollection,
  },
  data() {
    return {
      cardList: [],
      result: [],
      allShow: false,
      factoryShow: false,
      nameShow: false,
      machineShow: false,
      count: "",
      timer: null,
      instanceCode: [],
      focus: false,
      nameValue: "",
      pickerShow: false,
      columns: [],
      cascaderValue: "",
      selectBrand: {},
      brandValue: "",
      modelValue: "",
      unselectedName: "",
      selectValue: [],
      searchShow: true,
      allChecked: false,
      emptyShow: true,
    };
  },
  mounted() {
    this.getGroupList();
    this.$bus.$on("instanceOperate", (data) => {
      this.getGroupList();
    });
  },
  beforeDestroy() {
    // 给总线上的hello事件解绑
    this.$bus.$off("instanceOperate");
  },
  computed: {
    getDeviceType: {
      get() {
        return function (vipName, deviceVersionCode) {
          let item = buyCode.deviceIconOptions.find(
            (item) =>
              item.vipName == vipName &&
              item.deviceVersionCode == deviceVersionCode
          );
          if (item) {
            return item.deviceType;
          } else {
            if (deviceVersionCode) {
              return `定制${deviceVersionCode.substring(1)}`;
            } else {
              return "";
            }
          }
        };
      },
    },
  },
  methods: {
    // 获取分组信息
    getGroupList() {
      groupList()
        .then((res) => {
          if (res.code == 200) {
            for (let i = 0; i < res.data.length; i++) {
              res.data[i].showStatus = false;
            }
            let arr = res.data;
            for (let i = 0; i < arr.length; i++) {
              for (let k = 0; k < arr[i].instanceList.length; k++) {
                if (
                  arr[i].instanceList[k].overSoldDevice ||
                  arr[i].instanceList[k].isAuthorized == 1
                ) {
                  arr[i].instanceList.splice(k, 1);
                }
              }
            }
            this.cardList = arr;
            if (this.cardList.length <= 0) {
              this.emptyShow = false;
            }
          }
        })
        .catch((res) => {
          this.emptyShow = false;
        });
    },
    toggle(index, index1) {
      this.$refs["checkboxes" + index + index1][0].toggle();
      setTimeout(() => {
        let isTrue = this.$refs["checkboxes" + index][0].$children.every(
          (item) => item.checked == true
        );
        if (isTrue) {
          if (!this.cardList[index].result) {
            this.$refs["checkboxGroup" + index][0].toggle();
          }
        } else {
          if (this.cardList[index].result) {
            this.$refs["checkboxGroup" + index][0].toggle();
          }
        }
        this.generalAllChecked();
      }, 50);
    },

    // 全选，全不选
    checkAllMember(index, type) {
      // this.$refs.checkboxGroup
      // this.$refs["checkboxes" + index][0].toggleAll(type);
      if (type) {
        for (
          let i = 0;
          i < this.$refs["checkboxes" + index][0].$children.length;
          i++
        ) {
          this.$refs["checkboxes" + index][0].$children[i].checked = true;
          this.$refs["checkboxes" + index][0].$children[i].toggle(type);
        }
      } else {
        for (
          let i = 0;
          i < this.$refs["checkboxes" + index][0].$children.length;
          i++
        ) {
          this.$refs["checkboxes" + index][0].$children[i].checked = false;
          this.$refs["checkboxes" + index][0].$children[i].toggle(type);
        }
      }
      setTimeout(() => {
        this.generalAllChecked();
      }, 50);
    },
    // 总全选关联子项的是否全选
    generalAllChecked() {
      let type1 = true;
      try {
        this.cardList.forEach((item, index) => {
          type1 = this.$refs["checkboxes" + index][0].$children.every(
            (item) => item.checked == true
          );
          if (!type1) {
            throw new Error(); // 完全结束循环
          }
        });
      } catch (e) {
        // 异常处理
      }
      if (this.allChecked != type1) {
        this.allChecked = type1;
      }
    },
    // 二级关联子项的是否全选
    onAllChecked() {
      let that = this;
      if (!this.allChecked) {
        allCheckedType(true);
      } else {
        allCheckedType(false);
      }
      function allCheckedType(type) {
        that.cardList.forEach((item, index) => {
          that.$refs["checkboxGroup" + index][0].toggle(type);
          for (
            let i = 0;
            i < that.$refs["checkboxes" + index][0].$children.length;
            i++
          ) {
            that.$refs["checkboxes" + index][0].$children[i].checked = type;
            that.$refs["checkboxes" + index][0].$children[i].toggle(type);
          }
        });
      }
    },
    unfold(index) {
      this.cardList[index].showStatus = !this.cardList[index].showStatus;
    },
    onOperate(code) {
      if (!this.emptyShow) {
        Toast("没有可操作的云手机哦！");
        return;
      }
      switch (code) {
        case "批量续费":
          this.$router.push({
            path: "/batchRenew",
          });
          break;
        case "管理分组":
          this.$router.push("/grouping");
          break;
        case "复制ID":
          let value = this.result.map((item) => item.instanceId).join("\n");
          this.$common.moreCopy(value, "复制成功!");
          break;
        default:
          this.$refs.childRef.movement(code);
          break;
      }
    },
    formatSeconds(totalSeconds) {
      // 计算各时间单位
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      // 生成单位映射
      const units = ["天", "小时", "分"];
      // 构建结果数组
      const parts = [];
      if (days > 0) parts.push(`${days}${units[0]}`);
      if (hours > 0) parts.push(`${hours}${units[1]}`);
      if (minutes > 0 && totalSeconds < 86400)
        parts.push(`${minutes}${units[2]}`);
      // 处理全0情况
      if (parts.length === 0) return `0${units[3]}`;
      return parts.join("");
    },
  },
};
</script>
        
  <style lang="less" scoped>
.van-cell {
  padding: 12px 0;
}
.button {
  border: none;
  background: none;
}
.selectGrop {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}
.contentBox {
  font-family: MiSans, MiSans;
  padding: 0 10px 12px 10px;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  touch-action: manipulation;
  scrollbar-width: none;
  .card {
    margin-top: 10px;
    background-color: #fff;
    box-sizing: border-box;
    padding: 10px 0;
    border-radius: 10px;
    .information {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0px 16px;
      height: 42px;
      .mationLeft {
        width: 90%;
        .nameTop {
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 17px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          color: #333333;
          margin-bottom: 4px;
          margin-right: 12px;
          img {
            width: 17px;
          }
          .groupNameBox {
            display: flex;
            align-items: center;
            .groupName {
              font-weight: 500;
              font-size: 17px;
              color: #505465;
            }
            .instanceLength {
              font-weight: 400;
              font-size: 13px;
              color: #b8bdcc;
              line-height: 15px;
              margin-left: 8px;
            }
          }
        }
      }
      .mationRight {
        height: 24px;
        img {
          width: 24px;
        }
        .rightImg1 {
          margin-right: 12px;
        }
      }
    }
    .listEquipment:before {
      content: "";
      width: 319px;
      border: 1px solid #f5f7fb;
      height: 0px;
      position: absolute;
      top: -4px;
      left: 50%;
      transform: translateX(-50%);
    }
    .listEquipment {
      position: relative;
      margin-top: 17px;
      .listNape {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 64px;
      }
      .cellItem {
        padding: 5px 16px;
        border-radius: 12px;
      }
    }
  }
  .shebei_title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 8px;
    img {
      width: 40px;
      height: 40px;
      border-radius: 20px;
    }
    .shebei_content {
      // margin-left: 16px;
      text-align: left;
      p {
        margin: 0;
        height: 22px;
        font-size: 13px;
        font-weight: 400;
        color: #999999;
        line-height: 22px;
      }
      .p1 {
        font-weight: 500;
        font-size: 15px;
        color: #505465;
      }
      .p2 {
        display: flex;
        align-items: center;
        .idIcon {
          width: 18px;
          height: 17px;
          margin-right: 4px;
        }
        .id {
          font-weight: 500;
          font-size: 10px;
          color: #b8bdcc;
        }
      }
    }
    .instanceItem {
      font-weight: 400;
      font-size: 13px;
      color: #a9adb6;
    }
  }
  .check {
    margin-right: 2px;
  }
}
.baseBox {
  width: 100%;
  box-shadow: 0px -1px 2px 0px rgba(153, 153, 153, 0.1);
  padding: 14px 0;
  background: #f4f6fa;
  .selectBox {
    display: flex;
    justify-content: space-between;
    padding: 0 14px;
    .allSelect {
      display: flex;
    }
    .selectText {
      font-size: 13px;
      color: #505465;
    }
  }
  .baseText {
    font-size: 15px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: #666;
  }
  .ul {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    row-gap: 12px;
    column-gap: 17px;
    padding: 0 13px;
    margin-top: 12px;
    .li {
      text-align: center;
      display: inline-block;
      font-size: 14px;
      // margin: 6px 8px;
      background: #fff;
      border-radius: 13px;
      padding: 9px 0;
      img {
        width: 25px;
        height: 25px;
      }
      p {
        font-weight: 500;
        font-size: 10px;
        color: #505465;
        margin-top: 2px;
      }
    }
  }
}
.TitleBox {
  position: relative;
  img {
    width: 16px;
    position: absolute;
    top: 50%;
    right: 20px;
    transform: translate(-50%, -50%);
  }
}
.deleteTitle {
  font-size: 16px;
  font-weight: 400;
  color: #000;
  margin-top: 16px;
}
.hintText {
  font-size: 14px;
  font-weight: 400;
  color: #666;
  margin-top: 26px;
  padding: 0 24px;
}
.deleteOperate {
  margin: 38px auto 20px auto;
  .deleteCancel {
    width: 116px;
    height: 40px;
    background: #edeff3;
    border-radius: 4px;
    font-size: 16px;
    font-weight: 400;
    color: #9b9b9b;
    margin-right: 16px;
    line-height: 40px;
  }
  .deleteAffirm {
    width: 116px;
    height: 40px;
    background: #558bff;
    border-radius: 4px;
    font-size: 16px;
    font-weight: 400;
    color: #fff;
    line-height: 40px;
  }
  .machineCancel {
    width: 25%;
    height: 30px;
    background: #edeff3;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 400;
    color: #9b9b9b;
    line-height: 30px;
  }
  .machineAffirm {
    width: 25%;
    height: 34px;
    background: #558bff;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 400;
    color: #fff;
    line-height: 30px;
    margin-left: 12px;
  }
  .gram {
    background: #aaacb5;
  }
}
.wire {
  height: 1px;
  width: 85%;
  background-color: #f0ebeb;
  margin: 0 auto;
}
.blue {
  background-color: #558bff;
}
.van-cell::after {
  display: none;
}
/deep/ .van-field__control {
  // width: 315px;
  height: 40px;
  // background: #f5f5f5;
  // border-radius: 8px;
  // border: 1px solid #ebebeb;
  // margin: 24px auto 0 auto;
  // text-indent: 16px;
}
/deep/.van-tabs__wrap {
  display: block !important;
  padding-bottom: 18px;
}
/deep/.van-cascader__options {
  padding-top: 0;
}
/deep/.van-cascader__options {
  height: 300px;
}
.picker_toolbar {
  display: flex;
  align-items: center;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  height: 44px;
}
.picker_cancel {
  height: 100%;
  padding: 0 16px;
  font-size: 14px;
  background-color: transparent;
  border: none;
  cursor: pointer;
}
.picker_confirm {
  height: 100%;
  padding: 0 16px;
  font-size: 14px;
  background-color: transparent;
  border: none;
  cursor: pointer;
  color: #576b95;
}
.picker_title {
  max-width: 50%;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
}
/deep/.van-search__content--round {
  height: 40px;
}
/deep/.van-field__body {
  height: 20px !important;
}
/deep/.van-icon-search {
  margin-top: -2px;
}
</style>